import * as React from 'react';
import { IPaginatedLandingContent, PillColor } from '../models/paginated-landing-content'

interface IProps {
    content: IPaginatedLandingContent;
    fallbackImageUrl: string;
    showFallbackImage: boolean;
    topicPillColor: PillColor;
    rolePillColor: PillColor;
    ageRangePillColor: PillColor;
    contentTypePillColor: PillColor;
    specialtyPillColor: PillColor;
}

export class LandingPageContent extends React.Component<IProps, any> {
    renderPills() {
        const {
            content,
            topicPillColor,
            rolePillColor,
            ageRangePillColor,
            contentTypePillColor,
            specialtyPillColor
        } = this.props;

        const pillGroups: { values: any[]; color: PillColor }[] = [
            { values: content.topics, color: topicPillColor },
            { values: content.roles, color: rolePillColor },
            { values: content.ages, color: ageRangePillColor },
            { values: content.contentTypes, color: contentTypePillColor },
            { values: content.specialties, color: specialtyPillColor }
        ];

        const pills = pillGroups.reduce((acc, group) => {
            (group.values || [])
                .filter((value) => value != null && value !== '')
                .forEach((value) => acc.push({ value, color: group.color }));
            return acc;
        }, [] as { value: any; color: PillColor }[]);

        if (pills.length === 0) {
            return null;
        }

        return (
            <div className="paginated-template-item-pills">
                {pills.map((pill, index) => (
                    <span
                        key={`${pill.value}-${index}`}
                        className={`paginated-template-item-pill paginated-template-item-pill--${pill.color}`}>
                        {pill.value}
                    </span>
                ))}
            </div>
        );
    }

    render() {
        const { content } = this.props;
        return (
            <div className="paginated-template-item">
                <div className="paginated-template-item-content">
                    <h4 className="paginated-template-item-title">
                        <a href={content.url}>{content.title}</a>
                    </h4>
                    {content.date
                        ? <p className="paragraph-caption paginated-template-item-date">
                            <strong>
                                <span>{content.date}</span>
                            </strong>
                        </p>
                        : null
                    }
                    <p className="paragraph-caption paginated-template-item-desc">{content.description}</p>
                    {this.renderPills()}
                </div>
            </div>
        );
    }
}